import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Filters } from "@air/next-icons";
import { memo } from "react";
export const CommentsFilterBar = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "-mt-2.5 h-8",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center",
            children: [
                /*#__PURE__*/ _jsx(Filters, {
                    className: "mr-2 size-3 shrink-0 text-grey-10"
                }),
                children
            ]
        })
    });
});
CommentsFilterBar.displayName = "CommentsFilterBar";
